// Cytogenetic band definitions, generated from UCSC cytoBandIdeo.
//
// Bundled as a MODULE, not a fetched asset: `connect-src 'none'` blocks
// same-origin fetch too, so anything in public/ would be unreachable at runtime.
// Imported data is inlined by Vite into the module graph, governed by script-src.
//
// Both builds ship because the input formats disagree: 23andMe and AncestryDNA
// exports are GRCh37/hg19, while VCFs are usually GRCh38. Plotting hg19
// coordinates against hg38 bands puts variants at visibly wrong cytobands.
//
// Primary chromosomes only (1-22, X, Y); alt and random contigs are dropped.
// MT has no cytogenetic bands - it is a 16.6 kb circle, not a stained chromosome.

export type GenomeBuild = 'hg19' | 'hg38';

/** Giemsa stain result, indexed by the numbers in CYTOBANDS. */
export const STAINS = ["gneg","gpos25","gpos50","gpos75","gpos100","acen","gvar","stalk"] as const;
export type Stain = (typeof STAINS)[number];

/** [startBp, endBp, bandName, stainIndex] */
export type BandTuple = [number, number, string, number];

export const CYTOBANDS: Record<GenomeBuild, Record<string, BandTuple[]>> = {
  hg19: {"1":[[0,2300000,"p36.33",0],
    [2300000,5400000,"p36.32",1],
    [5400000,7200000,"p36.31",0],
    [7200000,9200000,"p36.23",1],
    [9200000,12700000,"p36.22",0],
    [12700000,16200000,"p36.21",2],
    [16200000,20400000,"p36.13",0],
    [20400000,23900000,"p36.12",1],
    [23900000,28000000,"p36.11",0],
    [28000000,30200000,"p35.3",1],
    [30200000,32400000,"p35.2",0],
    [32400000,34600000,"p35.1",1],
    [34600000,40100000,"p34.3",0],
    [40100000,44100000,"p34.2",1],
    [44100000,46800000,"p34.1",0],
    [46800000,50700000,"p33",3],
    [50700000,56100000,"p32.3",0],
    [56100000,59000000,"p32.2",2],
    [59000000,61300000,"p32.1",0],
    [61300000,68900000,"p31.3",2],
    [68900000,69700000,"p31.2",0],
    [69700000,84900000,"p31.1",4],
    [84900000,88400000,"p22.3",0],
    [88400000,92000000,"p22.2",3],
    [92000000,94700000,"p22.1",0],
    [94700000,99700000,"p21.3",3],
    [99700000,102200000,"p21.2",0],
    [102200000,107200000,"p21.1",4],
    [107200000,111800000,"p13.3",0],
    [111800000,116100000,"p13.2",2],
    [116100000,117800000,"p13.1",0],
    [117800000,120600000,"p12",2],
    [120600000,121500000,"p11.2",0],
    [121500000,125000000,"p11.1",5],
    [125000000,128900000,"q11",5],
    [128900000,142600000,"q12",6],
    [142600000,147000000,"q21.1",0],
    [147000000,150300000,"q21.2",2],
    [150300000,155000000,"q21.3",0],
    [155000000,156500000,"q22",2],
    [156500000,159100000,"q23.1",0],
    [159100000,160500000,"q23.2",2],
    [160500000,165500000,"q23.3",0],
    [165500000,167200000,"q24.1",2],
    [167200000,170900000,"q24.2",0],
    [170900000,172900000,"q24.3",3],
    [172900000,176000000,"q25.1",0],
    [176000000,180300000,"q25.2",2],
    [180300000,185800000,"q25.3",0],
    [185800000,190800000,"q31.1",4],
    [190800000,193800000,"q31.2",0],
    [193800000,198700000,"q31.3",4],
    [198700000,207200000,"q32.1",0],
    [207200000,211500000,"q32.2",1],
    [211500000,214500000,"q32.3",0],
    [214500000,224100000,"q41",4],
    [224100000,224600000,"q42.11",0],
    [224600000,227000000,"q42.12",1],
    [227000000,230700000,"q42.13",0],
    [230700000,234700000,"q42.2",2],
    [234700000,236600000,"q42.3",0],
    [236600000,243700000,"q43",3],
    [243700000,249250621,"q44",0]],"2":[[0,4400000,"p25.3",0],
    [4400000,7100000,"p25.2",2],
    [7100000,12200000,"p25.1",0],
    [12200000,16700000,"p24.3",3],
    [16700000,19200000,"p24.2",0],
    [19200000,24000000,"p24.1",3],
    [24000000,27900000,"p23.3",0],
    [27900000,30000000,"p23.2",1],
    [30000000,32100000,"p23.1",0],
    [32100000,36600000,"p22.3",3],
    [36600000,38600000,"p22.2",0],
    [38600000,41800000,"p22.1",2],
    [41800000,47800000,"p21",0],
    [47800000,52900000,"p16.3",4],
    [52900000,55000000,"p16.2",0],
    [55000000,61300000,"p16.1",4],
    [61300000,64100000,"p15",0],
    [64100000,68600000,"p14",2],
    [68600000,71500000,"p13.3",0],
    [71500000,73500000,"p13.2",2],
    [73500000,75000000,"p13.1",0],
    [75000000,83300000,"p12",4],
    [83300000,90500000,"p11.2",0],
    [90500000,93300000,"p11.1",5],
    [93300000,96800000,"q11.1",5],
    [96800000,102700000,"q11.2",0],
    [102700000,106000000,"q12.1",2],
    [106000000,107500000,"q12.2",0],
    [107500000,110200000,"q12.3",1],
    [110200000,114400000,"q13",0],
    [114400000,118800000,"q14.1",2],
    [118800000,122400000,"q14.2",0],
    [122400000,129900000,"q14.3",2],
    [129900000,132500000,"q21.1",0],
    [132500000,135100000,"q21.2",1],
    [135100000,136800000,"q21.3",0],
    [136800000,142200000,"q22.1",4],
    [142200000,144100000,"q22.2",0],
    [144100000,148700000,"q22.3",4],
    [148700000,149900000,"q23.1",0],
    [149900000,150500000,"q23.2",1],
    [150500000,154900000,"q23.3",0],
    [154900000,159800000,"q24.1",3],
    [159800000,163700000,"q24.2",0],
    [163700000,169700000,"q24.3",3],
    [169700000,178000000,"q31.1",0],
    [178000000,180600000,"q31.2",2],
    [180600000,183000000,"q31.3",0],
    [183000000,189400000,"q32.1",3],
    [189400000,191900000,"q32.2",0],
    [191900000,197400000,"q32.3",3],
    [197400000,203300000,"q33.1",0],
    [203300000,204900000,"q33.2",2],
    [204900000,209000000,"q33.3",0],
    [209000000,215300000,"q34",4],
    [215300000,221500000,"q35",0],
    [221500000,225200000,"q36.1",3],
    [225200000,226100000,"q36.2",0],
    [226100000,231000000,"q36.3",4],
    [231000000,235600000,"q37.1",0],
    [235600000,237300000,"q37.2",2],
    [237300000,243199373,"q37.3",0]],"3":[[0,2800000,"p26.3",2],
    [2800000,4000000,"p26.2",0],
    [4000000,8700000,"p26.1",2],
    [8700000,11800000,"p25.3",0],
    [11800000,13300000,"p25.2",1],
    [13300000,16400000,"p25.1",0],
    [16400000,23900000,"p24.3",4],
    [23900000,26400000,"p24.2",0],
    [26400000,30900000,"p24.1",3],
    [30900000,32100000,"p23",0],
    [32100000,36500000,"p22.3",2],
    [36500000,39400000,"p22.2",0],
    [39400000,43700000,"p22.1",3],
    [43700000,44100000,"p21.33",0],
    [44100000,44200000,"p21.32",2],
    [44200000,50600000,"p21.31",0],
    [50600000,52300000,"p21.2",1],
    [52300000,54400000,"p21.1",0],
    [54400000,58600000,"p14.3",2],
    [58600000,63700000,"p14.2",0],
    [63700000,69800000,"p14.1",2],
    [69800000,74200000,"p13",0],
    [74200000,79800000,"p12.3",3],
    [79800000,83500000,"p12.2",0],
    [83500000,87200000,"p12.1",3],
    [87200000,87900000,"p11.2",0],
    [87900000,91000000,"p11.1",5],
    [91000000,93900000,"q11.1",5],
    [93900000,98300000,"q11.2",6],
    [98300000,100000000,"q12.1",0],
    [100000000,100900000,"q12.2",1],
    [100900000,102800000,"q12.3",0],
    [102800000,106200000,"q13.11",3],
    [106200000,107900000,"q13.12",0],
    [107900000,111300000,"q13.13",2],
    [111300000,113500000,"q13.2",0],
    [113500000,117300000,"q13.31",3],
    [117300000,119000000,"q13.32",0],
    [119000000,121900000,"q13.33",3],
    [121900000,123800000,"q21.1",0],
    [123800000,125800000,"q21.2",1],
    [125800000,129200000,"q21.3",0],
    [129200000,133700000,"q22.1",1],
    [133700000,135700000,"q22.2",0],
    [135700000,138700000,"q22.3",1],
    [138700000,142800000,"q23",0],
    [142800000,148900000,"q24",4],
    [148900000,152100000,"q25.1",0],
    [152100000,155000000,"q25.2",2],
    [155000000,157000000,"q25.31",0],
    [157000000,159000000,"q25.32",2],
    [159000000,160700000,"q25.33",0],
    [160700000,167600000,"q26.1",4],
    [167600000,170900000,"q26.2",0],
    [170900000,175700000,"q26.31",3],
    [175700000,179000000,"q26.32",0],
    [179000000,182700000,"q26.33",3],
    [182700000,184500000,"q27.1",0],
    [184500000,186000000,"q27.2",1],
    [186000000,187900000,"q27.3",0],
    [187900000,192300000,"q28",3],
    [192300000,198022430,"q29",0]],"4":[[0,4500000,"p16.3",0],
    [4500000,6000000,"p16.2",1],
    [6000000,11300000,"p16.1",0],
    [11300000,15200000,"p15.33",2],
    [15200000,17800000,"p15.32",0],
    [17800000,21300000,"p15.31",3],
    [21300000,27700000,"p15.2",0],
    [27700000,35800000,"p15.1",4],
    [35800000,41200000,"p14",0],
    [41200000,44600000,"p13",2],
    [44600000,48200000,"p12",0],
    [48200000,50400000,"p11",5],
    [50400000,52700000,"q11",5],
    [52700000,59500000,"q12",0],
    [59500000,66600000,"q13.1",4],
    [66600000,70500000,"q13.2",0],
    [70500000,76300000,"q13.3",3],
    [76300000,78900000,"q21.1",0],
    [78900000,82400000,"q21.21",2],
    [82400000,84100000,"q21.22",0],
    [84100000,86900000,"q21.23",1],
    [86900000,88000000,"q21.3",0],
    [88000000,93700000,"q22.1",3],
    [93700000,95100000,"q22.2",0],
    [95100000,98800000,"q22.3",3],
    [98800000,101100000,"q23",0],
    [101100000,107700000,"q24",2],
    [107700000,114100000,"q25",0],
    [114100000,120800000,"q26",3],
    [120800000,123800000,"q27",0],
    [123800000,128800000,"q28.1",2],
    [128800000,131100000,"q28.2",0],
    [131100000,139500000,"q28.3",4],
    [139500000,141500000,"q31.1",0],
    [141500000,146800000,"q31.21",1],
    [146800000,148500000,"q31.22",0],
    [148500000,151100000,"q31.23",1],
    [151100000,155600000,"q31.3",0],
    [155600000,161800000,"q32.1",4],
    [161800000,164500000,"q32.2",0],
    [164500000,170100000,"q32.3",4],
    [170100000,171900000,"q33",0],
    [171900000,176300000,"q34.1",3],
    [176300000,177500000,"q34.2",0],
    [177500000,183200000,"q34.3",4],
    [183200000,187100000,"q35.1",0],
    [187100000,191154276,"q35.2",1]],"5":[[0,4500000,"p15.33",0],
    [4500000,6300000,"p15.32",1],
    [6300000,9800000,"p15.31",0],
    [9800000,15000000,"p15.2",2],
    [15000000,18400000,"p15.1",0],
    [18400000,23300000,"p14.3",4],
    [23300000,24600000,"p14.2",0],
    [24600000,28900000,"p14.1",4],
    [28900000,33800000,"p13.3",0],
    [33800000,38400000,"p13.2",1],
    [38400000,42500000,"p13.1",0],
    [42500000,46100000,"p12",2],
    [46100000,48400000,"p11",5],
    [48400000,50700000,"q11.1",5],
    [50700000,58900000,"q11.2",0],
    [58900000,62900000,"q12.1",3],
    [62900000,63200000,"q12.2",0],
    [63200000,66700000,"q12.3",3],
    [66700000,68400000,"q13.1",0],
    [68400000,73300000,"q13.2",2],
    [73300000,76900000,"q13.3",0],
    [76900000,81400000,"q14.1",2],
    [81400000,82800000,"q14.2",0],
    [82800000,92300000,"q14.3",4],
    [92300000,98200000,"q15",0],
    [98200000,102800000,"q21.1",4],
    [102800000,104500000,"q21.2",0],
    [104500000,109600000,"q21.3",4],
    [109600000,111500000,"q22.1",0],
    [111500000,113100000,"q22.2",2],
    [113100000,115200000,"q22.3",0],
    [115200000,121400000,"q23.1",4],
    [121400000,127300000,"q23.2",0],
    [127300000,130600000,"q23.3",4],
    [130600000,136200000,"q31.1",0],
    [136200000,139500000,"q31.2",1],
    [139500000,144500000,"q31.3",0],
    [144500000,149800000,"q32",3],
    [149800000,152700000,"q33.1",0],
    [152700000,155700000,"q33.2",2],
    [155700000,159900000,"q33.3",0],
    [159900000,168500000,"q34",4],
    [168500000,172800000,"q35.1",0],
    [172800000,176600000,"q35.2",1],
    [176600000,180915260,"q35.3",0]],"6":[[0,2300000,"p25.3",0],
    [2300000,4200000,"p25.2",1],
    [4200000,7100000,"p25.1",0],
    [7100000,10600000,"p24.3",2],
    [10600000,11600000,"p24.2",0],
    [11600000,13400000,"p24.1",1],
    [13400000,15200000,"p23",0],
    [15200000,25200000,"p22.3",3],
    [25200000,27000000,"p22.2",0],
    [27000000,30400000,"p22.1",2],
    [30400000,32100000,"p21.33",0],
    [32100000,33500000,"p21.32",1],
    [33500000,36600000,"p21.31",0],
    [36600000,40500000,"p21.2",1],
    [40500000,46200000,"p21.1",0],
    [46200000,51800000,"p12.3",4],
    [51800000,52900000,"p12.2",0],
    [52900000,57000000,"p12.1",4],
    [57000000,58700000,"p11.2",0],
    [58700000,61000000,"p11.1",5],
    [61000000,63300000,"q11.1",5],
    [63300000,63400000,"q11.2",0],
    [63400000,70000000,"q12",4],
    [70000000,75900000,"q13",0],
    [75900000,83900000,"q14.1",2],
    [83900000,84900000,"q14.2",0],
    [84900000,88000000,"q14.3",2],
    [88000000,93100000,"q15",0],
    [93100000,99500000,"q16.1",4],
    [99500000,100600000,"q16.2",0],
    [100600000,105500000,"q16.3",4],
    [105500000,114600000,"q21",0],
    [114600000,118300000,"q22.1",3],
    [118300000,118500000,"q22.2",0],
    [118500000,126100000,"q22.31",4],
    [126100000,127100000,"q22.32",0],
    [127100000,130300000,"q22.33",3],
    [130300000,131200000,"q23.1",0],
    [131200000,135200000,"q23.2",2],
    [135200000,139000000,"q23.3",0],
    [139000000,142800000,"q24.1",3],
    [142800000,145600000,"q24.2",0],
    [145600000,149000000,"q24.3",3],
    [149000000,152500000,"q25.1",0],
    [152500000,155500000,"q25.2",2],
    [155500000,161000000,"q25.3",0],
    [161000000,164500000,"q26",2],
    [164500000,171115067,"q27",0]],"7":[[0,2800000,"p22.3",0],
    [2800000,4500000,"p22.2",1],
    [4500000,7300000,"p22.1",0],
    [7300000,13800000,"p21.3",4],
    [13800000,16500000,"p21.2",0],
    [16500000,20900000,"p21.1",4],
    [20900000,25500000,"p15.3",0],
    [25500000,28000000,"p15.2",2],
    [28000000,28800000,"p15.1",0],
    [28800000,35000000,"p14.3",3],
    [35000000,37200000,"p14.2",0],
    [37200000,43300000,"p14.1",3],
    [43300000,45400000,"p13",0],
    [45400000,49000000,"p12.3",3],
    [49000000,50500000,"p12.2",0],
    [50500000,54000000,"p12.1",3],
    [54000000,58000000,"p11.2",0],
    [58000000,59900000,"p11.1",5],
    [59900000,61700000,"q11.1",5],
    [61700000,67000000,"q11.21",0],
    [67000000,72200000,"q11.22",2],
    [72200000,77500000,"q11.23",0],
    [77500000,86400000,"q21.11",4],
    [86400000,88200000,"q21.12",0],
    [88200000,91100000,"q21.13",3],
    [91100000,92800000,"q21.2",0],
    [92800000,98000000,"q21.3",3],
    [98000000,103800000,"q22.1",0],
    [103800000,104500000,"q22.2",2],
    [104500000,107400000,"q22.3",0],
    [107400000,114600000,"q31.1",3],
    [114600000,117400000,"q31.2",0],
    [117400000,121100000,"q31.31",3],
    [121100000,123800000,"q31.32",0],
    [123800000,127100000,"q31.33",3],
    [127100000,129200000,"q32.1",0],
    [129200000,130400000,"q32.2",1],
    [130400000,132600000,"q32.3",0],
    [132600000,138200000,"q33",2],
    [138200000,143100000,"q34",0],
    [143100000,147900000,"q35",3],
    [147900000,152600000,"q36.1",0],
    [152600000,155100000,"q36.2",1],
    [155100000,159138663,"q36.3",0]],"8":[[0,2200000,"p23.3",0],
    [2200000,6200000,"p23.2",3],
    [6200000,12700000,"p23.1",0],
    [12700000,19000000,"p22",4],
    [19000000,23300000,"p21.3",0],
    [23300000,27400000,"p21.2",2],
    [27400000,28800000,"p21.1",0],
    [28800000,36500000,"p12",3],
    [36500000,38300000,"p11.23",0],
    [38300000,39700000,"p11.22",1],
    [39700000,43100000,"p11.21",0],
    [43100000,45600000,"p11.1",5],
    [45600000,48100000,"q11.1",5],
    [48100000,52200000,"q11.21",0],
    [52200000,52600000,"q11.22",3],
    [52600000,55500000,"q11.23",0],
    [55500000,61600000,"q12.1",2],
    [61600000,62200000,"q12.2",0],
    [62200000,66000000,"q12.3",2],
    [66000000,68000000,"q13.1",0],
    [68000000,70500000,"q13.2",2],
    [70500000,73900000,"q13.3",0],
    [73900000,78300000,"q21.11",4],
    [78300000,80100000,"q21.12",0],
    [80100000,84600000,"q21.13",3],
    [84600000,86900000,"q21.2",0],
    [86900000,93300000,"q21.3",4],
    [93300000,99000000,"q22.1",0],
    [99000000,101600000,"q22.2",1],
    [101600000,106200000,"q22.3",0],
    [106200000,110500000,"q23.1",3],
    [110500000,112100000,"q23.2",0],
    [112100000,117700000,"q23.3",4],
    [117700000,119200000,"q24.11",0],
    [119200000,122500000,"q24.12",2],
    [122500000,127300000,"q24.13",0],
    [127300000,131500000,"q24.21",2],
    [131500000,136400000,"q24.22",0],
    [136400000,139900000,"q24.23",3],
    [139900000,146364022,"q24.3",0]],"9":[[0,2200000,"p24.3",0],
    [2200000,4600000,"p24.2",1],
    [4600000,9000000,"p24.1",0],
    [9000000,14200000,"p23",3],
    [14200000,16600000,"p22.3",0],
    [16600000,18500000,"p22.2",1],
    [18500000,19900000,"p22.1",0],
    [19900000,25600000,"p21.3",4],
    [25600000,28000000,"p21.2",0],
    [28000000,33200000,"p21.1",4],
    [33200000,36300000,"p13.3",0],
    [36300000,38400000,"p13.2",1],
    [38400000,41000000,"p13.1",0],
    [41000000,43600000,"p12",2],
    [43600000,47300000,"p11.2",0],
    [47300000,49000000,"p11.1",5],
    [49000000,50700000,"q11",5],
    [50700000,65900000,"q12",6],
    [65900000,68700000,"q13",0],
    [68700000,72200000,"q21.11",1],
    [72200000,74000000,"q21.12",0],
    [74000000,79200000,"q21.13",2],
    [79200000,81100000,"q21.2",0],
    [81100000,84100000,"q21.31",2],
    [84100000,86900000,"q21.32",0],
    [86900000,90400000,"q21.33",2],
    [90400000,91800000,"q22.1",0],
    [91800000,93900000,"q22.2",1],
    [93900000,96600000,"q22.31",0],
    [96600000,99300000,"q22.32",1],
    [99300000,102600000,"q22.33",0],
    [102600000,108200000,"q31.1",4],
    [108200000,111300000,"q31.2",0],
    [111300000,114900000,"q31.3",1],
    [114900000,117700000,"q32",0],
    [117700000,122500000,"q33.1",3],
    [122500000,125800000,"q33.2",0],
    [125800000,130300000,"q33.3",1],
    [130300000,133500000,"q34.11",0],
    [133500000,134000000,"q34.12",1],
    [134000000,135900000,"q34.13",0],
    [135900000,137400000,"q34.2",1],
    [137400000,141213431,"q34.3",0]],"10":[[0,3000000,"p15.3",0],
    [3000000,3800000,"p15.2",1],
    [3800000,6600000,"p15.1",0],
    [6600000,12200000,"p14",3],
    [12200000,17300000,"p13",0],
    [17300000,18600000,"p12.33",3],
    [18600000,18700000,"p12.32",0],
    [18700000,22600000,"p12.31",3],
    [22600000,24600000,"p12.2",0],
    [24600000,29600000,"p12.1",2],
    [29600000,31300000,"p11.23",0],
    [31300000,34400000,"p11.22",1],
    [34400000,38000000,"p11.21",0],
    [38000000,40200000,"p11.1",5],
    [40200000,42300000,"q11.1",5],
    [42300000,46100000,"q11.21",0],
    [46100000,49900000,"q11.22",1],
    [49900000,52900000,"q11.23",0],
    [52900000,61200000,"q21.1",4],
    [61200000,64500000,"q21.2",0],
    [64500000,70600000,"q21.3",4],
    [70600000,74900000,"q22.1",0],
    [74900000,77700000,"q22.2",2],
    [77700000,82000000,"q22.3",0],
    [82000000,87900000,"q23.1",4],
    [87900000,89500000,"q23.2",0],
    [89500000,92900000,"q23.31",3],
    [92900000,94100000,"q23.32",0],
    [94100000,97000000,"q23.33",2],
    [97000000,99300000,"q24.1",0],
    [99300000,101900000,"q24.2",2],
    [101900000,103000000,"q24.31",0],
    [103000000,104900000,"q24.32",1],
    [104900000,105800000,"q24.33",0],
    [105800000,111900000,"q25.1",4],
    [111900000,114900000,"q25.2",0],
    [114900000,119100000,"q25.3",3],
    [119100000,121700000,"q26.11",0],
    [121700000,123100000,"q26.12",2],
    [123100000,127500000,"q26.13",0],
    [127500000,130600000,"q26.2",2],
    [130600000,135534747,"q26.3",0]],"11":[[0,2800000,"p15.5",0],
    [2800000,10700000,"p15.4",2],
    [10700000,12700000,"p15.3",0],
    [12700000,16200000,"p15.2",2],
    [16200000,21700000,"p15.1",0],
    [21700000,26100000,"p14.3",4],
    [26100000,27200000,"p14.2",0],
    [27200000,31000000,"p14.1",3],
    [31000000,36400000,"p13",0],
    [36400000,43500000,"p12",4],
    [43500000,48800000,"p11.2",0],
    [48800000,51600000,"p11.12",3],
    [51600000,53700000,"p11.11",5],
    [53700000,55700000,"q11",5],
    [55700000,59900000,"q12.1",3],
    [59900000,61700000,"q12.2",0],
    [61700000,63400000,"q12.3",1],
    [63400000,65900000,"q13.1",0],
    [65900000,68400000,"q13.2",1],
    [68400000,70400000,"q13.3",0],
    [70400000,75200000,"q13.4",2],
    [75200000,77100000,"q13.5",0],
    [77100000,85600000,"q14.1",4],
    [85600000,88300000,"q14.2",0],
    [88300000,92800000,"q14.3",4],
    [92800000,97200000,"q21",0],
    [97200000,102100000,"q22.1",4],
    [102100000,102900000,"q22.2",0],
    [102900000,110400000,"q22.3",4],
    [110400000,112500000,"q23.1",0],
    [112500000,114500000,"q23.2",2],
    [114500000,121200000,"q23.3",0],
    [121200000,123900000,"q24.1",2],
    [123900000,127800000,"q24.2",0],
    [127800000,130800000,"q24.3",2],
    [130800000,135006516,"q25",0]],"12":[[0,3300000,"p13.33",0],
    [3300000,5400000,"p13.32",1],
    [5400000,10100000,"p13.31",0],
    [10100000,12800000,"p13.2",3],
    [12800000,14800000,"p13.1",0],
    [14800000,20000000,"p12.3",4],
    [20000000,21300000,"p12.2",0],
    [21300000,26500000,"p12.1",4],
    [26500000,27800000,"p11.23",0],
    [27800000,30700000,"p11.22",2],
    [30700000,33300000,"p11.21",0],
    [33300000,35800000,"p11.1",5],
    [35800000,38200000,"q11",5],
    [38200000,46400000,"q12",4],
    [46400000,49100000,"q13.11",0],
    [49100000,51500000,"q13.12",1],
    [51500000,54900000,"q13.13",0],
    [54900000,56600000,"q13.2",1],
    [56600000,58100000,"q13.3",0],
    [58100000,63100000,"q14.1",3],
    [63100000,65100000,"q14.2",0],
    [65100000,67700000,"q14.3",2],
    [67700000,71500000,"q15",0],
    [71500000,75700000,"q21.1",3],
    [75700000,80300000,"q21.2",0],
    [80300000,86700000,"q21.31",4],
    [86700000,89000000,"q21.32",0],
    [89000000,92600000,"q21.33",4],
    [92600000,96200000,"q22",0],
    [96200000,101600000,"q23.1",3],
    [101600000,103800000,"q23.2",0],
    [103800000,109000000,"q23.3",2],
    [109000000,111700000,"q24.11",0],
    [111700000,112300000,"q24.12",1],
    [112300000,114300000,"q24.13",0],
    [114300000,116800000,"q24.21",2],
    [116800000,118100000,"q24.22",0],
    [118100000,120700000,"q24.23",2],
    [120700000,125900000,"q24.31",0],
    [125900000,129300000,"q24.32",2],
    [129300000,133851895,"q24.33",0]],"13":[[0,4500000,"p13",6],
    [4500000,10000000,"p12",7],
    [10000000,16300000,"p11.2",6],
    [16300000,17900000,"p11.1",5],
    [17900000,19500000,"q11",5],
    [19500000,23300000,"q12.11",0],
    [23300000,25500000,"q12.12",1],
    [25500000,27800000,"q12.13",0],
    [27800000,28900000,"q12.2",1],
    [28900000,32200000,"q12.3",0],
    [32200000,34000000,"q13.1",2],
    [34000000,35500000,"q13.2",0],
    [35500000,40100000,"q13.3",3],
    [40100000,45200000,"q14.11",0],
    [45200000,45800000,"q14.12",1],
    [45800000,47300000,"q14.13",0],
    [47300000,50900000,"q14.2",2],
    [50900000,55300000,"q14.3",0],
    [55300000,59600000,"q21.1",4],
    [59600000,62300000,"q21.2",0],
    [62300000,65700000,"q21.31",3],
    [65700000,68600000,"q21.32",0],
    [68600000,73300000,"q21.33",4],
    [73300000,75400000,"q22.1",0],
    [75400000,77200000,"q22.2",2],
    [77200000,79000000,"q22.3",0],
    [79000000,87700000,"q31.1",4],
    [87700000,90000000,"q31.2",0],
    [90000000,95000000,"q31.3",4],
    [95000000,98200000,"q32.1",0],
    [98200000,99300000,"q32.2",1],
    [99300000,101700000,"q32.3",0],
    [101700000,104800000,"q33.1",4],
    [104800000,107000000,"q33.2",0],
    [107000000,110300000,"q33.3",4],
    [110300000,115169878,"q34",0]],"14":[[0,3700000,"p13",6],
    [3700000,8100000,"p12",7],
    [8100000,16100000,"p11.2",6],
    [16100000,17600000,"p11.1",5],
    [17600000,19100000,"q11.1",5],
    [19100000,24600000,"q11.2",0],
    [24600000,33300000,"q12",4],
    [33300000,35300000,"q13.1",0],
    [35300000,36600000,"q13.2",2],
    [36600000,37800000,"q13.3",0],
    [37800000,43500000,"q21.1",4],
    [43500000,47200000,"q21.2",0],
    [47200000,50900000,"q21.3",4],
    [50900000,54100000,"q22.1",0],
    [54100000,55500000,"q22.2",1],
    [55500000,58100000,"q22.3",0],
    [58100000,62100000,"q23.1",3],
    [62100000,64800000,"q23.2",0],
    [64800000,67900000,"q23.3",2],
    [67900000,70200000,"q24.1",0],
    [70200000,73800000,"q24.2",2],
    [73800000,79300000,"q24.3",0],
    [79300000,83600000,"q31.1",4],
    [83600000,84900000,"q31.2",0],
    [84900000,89800000,"q31.3",4],
    [89800000,91900000,"q32.11",0],
    [91900000,94700000,"q32.12",1],
    [94700000,96300000,"q32.13",0],
    [96300000,101400000,"q32.2",2],
    [101400000,103200000,"q32.31",0],
    [103200000,104000000,"q32.32",2],
    [104000000,107349540,"q32.33",0]],"15":[[0,3900000,"p13",6],
    [3900000,8700000,"p12",7],
    [8700000,15800000,"p11.2",6],
    [15800000,19000000,"p11.1",5],
    [19000000,20700000,"q11.1",5],
    [20700000,25700000,"q11.2",0],
    [25700000,28100000,"q12",2],
    [28100000,30300000,"q13.1",0],
    [30300000,31200000,"q13.2",2],
    [31200000,33600000,"q13.3",0],
    [33600000,40100000,"q14",3],
    [40100000,42800000,"q15.1",0],
    [42800000,43600000,"q15.2",1],
    [43600000,44800000,"q15.3",0],
    [44800000,49500000,"q21.1",3],
    [49500000,52900000,"q21.2",0],
    [52900000,59100000,"q21.3",3],
    [59100000,59300000,"q22.1",0],
    [59300000,63700000,"q22.2",1],
    [63700000,67200000,"q22.31",0],
    [67200000,67300000,"q22.32",1],
    [67300000,67500000,"q22.33",0],
    [67500000,72700000,"q23",1],
    [72700000,75200000,"q24.1",0],
    [75200000,76600000,"q24.2",1],
    [76600000,78300000,"q24.3",0],
    [78300000,81700000,"q25.1",2],
    [81700000,85200000,"q25.2",0],
    [85200000,89100000,"q25.3",2],
    [89100000,94300000,"q26.1",0],
    [94300000,98500000,"q26.2",2],
    [98500000,102531392,"q26.3",0]],"16":[[0,7900000,"p13.3",0],
    [7900000,10500000,"p13.2",2],
    [10500000,12600000,"p13.13",0],
    [12600000,14800000,"p13.12",2],
    [14800000,16800000,"p13.11",0],
    [16800000,21200000,"p12.3",2],
    [21200000,24200000,"p12.2",0],
    [24200000,28100000,"p12.1",2],
    [28100000,34600000,"p11.2",0],
    [34600000,36600000,"p11.1",5],
    [36600000,38600000,"q11.1",5],
    [38600000,47000000,"q11.2",6],
    [47000000,52600000,"q12.1",0],
    [52600000,56700000,"q12.2",2],
    [56700000,57400000,"q13",0],
    [57400000,66700000,"q21",4],
    [66700000,70800000,"q22.1",0],
    [70800000,72900000,"q22.2",2],
    [72900000,74100000,"q22.3",0],
    [74100000,79200000,"q23.1",3],
    [79200000,81700000,"q23.2",0],
    [81700000,84200000,"q23.3",2],
    [84200000,87100000,"q24.1",0],
    [87100000,88700000,"q24.2",1],
    [88700000,90354753,"q24.3",0]],"17":[[0,3300000,"p13.3",0],
    [3300000,6500000,"p13.2",2],
    [6500000,10700000,"p13.1",0],
    [10700000,16000000,"p12",3],
    [16000000,22200000,"p11.2",0],
    [22200000,24000000,"p11.1",5],
    [24000000,25800000,"q11.1",5],
    [25800000,31800000,"q11.2",0],
    [31800000,38100000,"q12",2],
    [38100000,38400000,"q21.1",0],
    [38400000,40900000,"q21.2",1],
    [40900000,44900000,"q21.31",0],
    [44900000,47400000,"q21.32",1],
    [47400000,50200000,"q21.33",0],
    [50200000,57600000,"q22",3],
    [57600000,58300000,"q23.1",0],
    [58300000,61100000,"q23.2",3],
    [61100000,62600000,"q23.3",0],
    [62600000,64200000,"q24.1",2],
    [64200000,67100000,"q24.2",0],
    [67100000,70900000,"q24.3",3],
    [70900000,74800000,"q25.1",0],
    [74800000,75300000,"q25.2",1],
    [75300000,81195210,"q25.3",0]],"18":[[0,2900000,"p11.32",0],
    [2900000,7100000,"p11.31",2],
    [7100000,8500000,"p11.23",0],
    [8500000,10900000,"p11.22",1],
    [10900000,15400000,"p11.21",0],
    [15400000,17200000,"p11.1",5],
    [17200000,19000000,"q11.1",5],
    [19000000,25000000,"q11.2",0],
    [25000000,32700000,"q12.1",4],
    [32700000,37200000,"q12.2",0],
    [37200000,43500000,"q12.3",3],
    [43500000,48200000,"q21.1",0],
    [48200000,53800000,"q21.2",3],
    [53800000,56200000,"q21.31",0],
    [56200000,59000000,"q21.32",2],
    [59000000,61600000,"q21.33",0],
    [61600000,66800000,"q22.1",4],
    [66800000,68700000,"q22.2",0],
    [68700000,73100000,"q22.3",1],
    [73100000,78077248,"q23",0]],"19":[[0,6900000,"p13.3",0],
    [6900000,13900000,"p13.2",1],
    [13900000,14000000,"p13.13",0],
    [14000000,16300000,"p13.12",1],
    [16300000,20000000,"p13.11",0],
    [20000000,24400000,"p12",6],
    [24400000,26500000,"p11",5],
    [26500000,28600000,"q11",5],
    [28600000,32400000,"q12",6],
    [32400000,35500000,"q13.11",0],
    [35500000,38300000,"q13.12",1],
    [38300000,38700000,"q13.13",0],
    [38700000,43400000,"q13.2",1],
    [43400000,45200000,"q13.31",0],
    [45200000,48000000,"q13.32",1],
    [48000000,51400000,"q13.33",0],
    [51400000,53600000,"q13.41",1],
    [53600000,56300000,"q13.42",0],
    [56300000,59128983,"q13.43",1]],"20":[[0,5100000,"p13",0],
    [5100000,9200000,"p12.3",3],
    [9200000,12100000,"p12.2",0],
    [12100000,17900000,"p12.1",3],
    [17900000,21300000,"p11.23",0],
    [21300000,22300000,"p11.22",1],
    [22300000,25600000,"p11.21",0],
    [25600000,27500000,"p11.1",5],
    [27500000,29400000,"q11.1",5],
    [29400000,32100000,"q11.21",0],
    [32100000,34400000,"q11.22",1],
    [34400000,37600000,"q11.23",0],
    [37600000,41700000,"q12",3],
    [41700000,42100000,"q13.11",0],
    [42100000,46400000,"q13.12",1],
    [46400000,49800000,"q13.13",0],
    [49800000,55000000,"q13.2",3],
    [55000000,56500000,"q13.31",0],
    [56500000,58400000,"q13.32",2],
    [58400000,63025520,"q13.33",0]],"21":[[0,2800000,"p13",6],
    [2800000,6800000,"p12",7],
    [6800000,10900000,"p11.2",6],
    [10900000,13200000,"p11.1",5],
    [13200000,14300000,"q11.1",5],
    [14300000,16400000,"q11.2",0],
    [16400000,24000000,"q21.1",4],
    [24000000,26800000,"q21.2",0],
    [26800000,31500000,"q21.3",3],
    [31500000,35800000,"q22.11",0],
    [35800000,37800000,"q22.12",2],
    [37800000,39700000,"q22.13",0],
    [39700000,42600000,"q22.2",2],
    [42600000,48129895,"q22.3",0]],"22":[[0,3800000,"p13",6],
    [3800000,8300000,"p12",7],
    [8300000,12200000,"p11.2",6],
    [12200000,14700000,"p11.1",5],
    [14700000,17900000,"q11.1",5],
    [17900000,22200000,"q11.21",0],
    [22200000,23500000,"q11.22",1],
    [23500000,25900000,"q11.23",0],
    [25900000,29600000,"q12.1",2],
    [29600000,32200000,"q12.2",0],
    [32200000,37600000,"q12.3",2],
    [37600000,41000000,"q13.1",0],
    [41000000,44200000,"q13.2",2],
    [44200000,48400000,"q13.31",0],
    [48400000,49400000,"q13.32",2],
    [49400000,51304566,"q13.33",0]],"X":[[0,4300000,"p22.33",0],
    [4300000,6000000,"p22.32",2],
    [6000000,9500000,"p22.31",0],
    [9500000,17100000,"p22.2",2],
    [17100000,19300000,"p22.13",0],
    [19300000,21900000,"p22.12",2],
    [21900000,24900000,"p22.11",0],
    [24900000,29300000,"p21.3",4],
    [29300000,31500000,"p21.2",0],
    [31500000,37600000,"p21.1",4],
    [37600000,42400000,"p11.4",0],
    [42400000,46400000,"p11.3",3],
    [46400000,49800000,"p11.23",0],
    [49800000,54800000,"p11.22",1],
    [54800000,58100000,"p11.21",0],
    [58100000,60600000,"p11.1",5],
    [60600000,63000000,"q11.1",5],
    [63000000,64600000,"q11.2",0],
    [64600000,67800000,"q12",2],
    [67800000,71800000,"q13.1",0],
    [71800000,73900000,"q13.2",2],
    [73900000,76000000,"q13.3",0],
    [76000000,84600000,"q21.1",4],
    [84600000,86200000,"q21.2",0],
    [86200000,91800000,"q21.31",4],
    [91800000,93500000,"q21.32",0],
    [93500000,98300000,"q21.33",3],
    [98300000,102600000,"q22.1",0],
    [102600000,103700000,"q22.2",2],
    [103700000,108700000,"q22.3",0],
    [108700000,116500000,"q23",3],
    [116500000,120900000,"q24",0],
    [120900000,128700000,"q25",4],
    [128700000,130400000,"q26.1",0],
    [130400000,133600000,"q26.2",1],
    [133600000,138000000,"q26.3",0],
    [138000000,140300000,"q27.1",3],
    [140300000,142100000,"q27.2",0],
    [142100000,147100000,"q27.3",4],
    [147100000,155270560,"q28",0]],"Y":[[0,2500000,"p11.32",0],
    [2500000,3000000,"p11.31",2],
    [3000000,11600000,"p11.2",0],
    [11600000,12500000,"p11.1",5],
    [12500000,13400000,"q11.1",5],
    [13400000,15100000,"q11.21",0],
    [15100000,19800000,"q11.221",2],
    [19800000,22100000,"q11.222",0],
    [22100000,26200000,"q11.223",2],
    [26200000,28800000,"q11.23",0],
    [28800000,59373566,"q12",6]]},
  hg38: {"1":[[0,2300000,"p36.33",0],
    [2300000,5300000,"p36.32",1],
    [5300000,7100000,"p36.31",0],
    [7100000,9100000,"p36.23",1],
    [9100000,12500000,"p36.22",0],
    [12500000,15900000,"p36.21",2],
    [15900000,20100000,"p36.13",0],
    [20100000,23600000,"p36.12",1],
    [23600000,27600000,"p36.11",0],
    [27600000,29900000,"p35.3",1],
    [29900000,32300000,"p35.2",0],
    [32300000,34300000,"p35.1",1],
    [34300000,39600000,"p34.3",0],
    [39600000,43700000,"p34.2",1],
    [43700000,46300000,"p34.1",0],
    [46300000,50200000,"p33",3],
    [50200000,55600000,"p32.3",0],
    [55600000,58500000,"p32.2",2],
    [58500000,60800000,"p32.1",0],
    [60800000,68500000,"p31.3",2],
    [68500000,69300000,"p31.2",0],
    [69300000,84400000,"p31.1",4],
    [84400000,87900000,"p22.3",0],
    [87900000,91500000,"p22.2",3],
    [91500000,94300000,"p22.1",0],
    [94300000,99300000,"p21.3",3],
    [99300000,101800000,"p21.2",0],
    [101800000,106700000,"p21.1",4],
    [106700000,111200000,"p13.3",0],
    [111200000,115500000,"p13.2",2],
    [115500000,117200000,"p13.1",0],
    [117200000,120400000,"p12",2],
    [120400000,121700000,"p11.2",0],
    [121700000,123400000,"p11.1",5],
    [123400000,125100000,"q11",5],
    [125100000,143200000,"q12",6],
    [143200000,147500000,"q21.1",0],
    [147500000,150600000,"q21.2",2],
    [150600000,155100000,"q21.3",0],
    [155100000,156600000,"q22",2],
    [156600000,159100000,"q23.1",0],
    [159100000,160500000,"q23.2",2],
    [160500000,165500000,"q23.3",0],
    [165500000,167200000,"q24.1",2],
    [167200000,170900000,"q24.2",0],
    [170900000,173000000,"q24.3",3],
    [173000000,176100000,"q25.1",0],
    [176100000,180300000,"q25.2",2],
    [180300000,185800000,"q25.3",0],
    [185800000,190800000,"q31.1",4],
    [190800000,193800000,"q31.2",0],
    [193800000,198700000,"q31.3",4],
    [198700000,207100000,"q32.1",0],
    [207100000,211300000,"q32.2",1],
    [211300000,214400000,"q32.3",0],
    [214400000,223900000,"q41",4],
    [223900000,224400000,"q42.11",0],
    [224400000,226800000,"q42.12",1],
    [226800000,230500000,"q42.13",0],
    [230500000,234600000,"q42.2",2],
    [234600000,236400000,"q42.3",0],
    [236400000,243500000,"q43",3],
    [243500000,248956422,"q44",0]],"2":[[0,4400000,"p25.3",0],
    [4400000,6900000,"p25.2",2],
    [6900000,12000000,"p25.1",0],
    [12000000,16500000,"p24.3",3],
    [16500000,19000000,"p24.2",0],
    [19000000,23800000,"p24.1",3],
    [23800000,27700000,"p23.3",0],
    [27700000,29800000,"p23.2",1],
    [29800000,31800000,"p23.1",0],
    [31800000,36300000,"p22.3",3],
    [36300000,38300000,"p22.2",0],
    [38300000,41500000,"p22.1",2],
    [41500000,47500000,"p21",0],
    [47500000,52600000,"p16.3",4],
    [52600000,54700000,"p16.2",0],
    [54700000,61000000,"p16.1",4],
    [61000000,63900000,"p15",0],
    [63900000,68400000,"p14",2],
    [68400000,71300000,"p13.3",0],
    [71300000,73300000,"p13.2",2],
    [73300000,74800000,"p13.1",0],
    [74800000,83100000,"p12",4],
    [83100000,91800000,"p11.2",0],
    [91800000,93900000,"p11.1",5],
    [93900000,96000000,"q11.1",5],
    [96000000,102100000,"q11.2",0],
    [102100000,105300000,"q12.1",2],
    [105300000,106700000,"q12.2",0],
    [106700000,108700000,"q12.3",1],
    [108700000,112200000,"q13",0],
    [112200000,118100000,"q14.1",2],
    [118100000,121600000,"q14.2",0],
    [121600000,129100000,"q14.3",2],
    [129100000,131700000,"q21.1",0],
    [131700000,134300000,"q21.2",1],
    [134300000,136100000,"q21.3",0],
    [136100000,141500000,"q22.1",4],
    [141500000,143400000,"q22.2",0],
    [143400000,147900000,"q22.3",4],
    [147900000,149000000,"q23.1",0],
    [149000000,149600000,"q23.2",1],
    [149600000,154000000,"q23.3",0],
    [154000000,158900000,"q24.1",3],
    [158900000,162900000,"q24.2",0],
    [162900000,168900000,"q24.3",3],
    [168900000,177100000,"q31.1",0],
    [177100000,179700000,"q31.2",2],
    [179700000,182100000,"q31.3",0],
    [182100000,188500000,"q32.1",3],
    [188500000,191100000,"q32.2",0],
    [191100000,196600000,"q32.3",3],
    [196600000,202500000,"q33.1",0],
    [202500000,204100000,"q33.2",2],
    [204100000,208200000,"q33.3",0],
    [208200000,214500000,"q34",4],
    [214500000,220700000,"q35",0],
    [220700000,224300000,"q36.1",3],
    [224300000,225200000,"q36.2",0],
    [225200000,230100000,"q36.3",4],
    [230100000,234700000,"q37.1",0],
    [234700000,236400000,"q37.2",2],
    [236400000,242193529,"q37.3",0]],"3":[[0,2800000,"p26.3",2],
    [2800000,4000000,"p26.2",0],
    [4000000,8100000,"p26.1",2],
    [8100000,11600000,"p25.3",0],
    [11600000,13200000,"p25.2",1],
    [13200000,16300000,"p25.1",0],
    [16300000,23800000,"p24.3",4],
    [23800000,26300000,"p24.2",0],
    [26300000,30800000,"p24.1",3],
    [30800000,32000000,"p23",0],
    [32000000,36400000,"p22.3",2],
    [36400000,39300000,"p22.2",0],
    [39300000,43600000,"p22.1",3],
    [43600000,44100000,"p21.33",0],
    [44100000,44200000,"p21.32",2],
    [44200000,50600000,"p21.31",0],
    [50600000,52300000,"p21.2",1],
    [52300000,54400000,"p21.1",0],
    [54400000,58600000,"p14.3",2],
    [58600000,63800000,"p14.2",0],
    [63800000,69700000,"p14.1",2],
    [69700000,74100000,"p13",0],
    [74100000,79800000,"p12.3",3],
    [79800000,83500000,"p12.2",0],
    [83500000,87100000,"p12.1",3],
    [87100000,87800000,"p11.2",0],
    [87800000,90900000,"p11.1",5],
    [90900000,94000000,"q11.1",5],
    [94000000,98600000,"q11.2",6],
    [98600000,100300000,"q12.1",0],
    [100300000,101200000,"q12.2",1],
    [101200000,103100000,"q12.3",0],
    [103100000,106500000,"q13.11",3],
    [106500000,108200000,"q13.12",0],
    [108200000,111600000,"q13.13",2],
    [111600000,113700000,"q13.2",0],
    [113700000,117600000,"q13.31",3],
    [117600000,119300000,"q13.32",0],
    [119300000,122200000,"q13.33",3],
    [122200000,124100000,"q21.1",0],
    [124100000,126100000,"q21.2",1],
    [126100000,129500000,"q21.3",0],
    [129500000,134000000,"q22.1",1],
    [134000000,136000000,"q22.2",0],
    [136000000,139000000,"q22.3",1],
    [139000000,143100000,"q23",0],
    [143100000,149200000,"q24",4],
    [149200000,152300000,"q25.1",0],
    [152300000,155300000,"q25.2",2],
    [155300000,157300000,"q25.31",0],
    [157300000,159300000,"q25.32",2],
    [159300000,161000000,"q25.33",0],
    [161000000,167900000,"q26.1",4],
    [167900000,171200000,"q26.2",0],
    [171200000,176000000,"q26.31",3],
    [176000000,179300000,"q26.32",0],
    [179300000,183000000,"q26.33",3],
    [183000000,184800000,"q27.1",0],
    [184800000,186300000,"q27.2",1],
    [186300000,188200000,"q27.3",0],
    [188200000,192600000,"q28",3],
    [192600000,198295559,"q29",0]],"4":[[0,4500000,"p16.3",0],
    [4500000,6000000,"p16.2",1],
    [6000000,11300000,"p16.1",0],
    [11300000,15000000,"p15.33",2],
    [15000000,17700000,"p15.32",0],
    [17700000,21300000,"p15.31",3],
    [21300000,27700000,"p15.2",0],
    [27700000,35800000,"p15.1",4],
    [35800000,41200000,"p14",0],
    [41200000,44600000,"p13",2],
    [44600000,48200000,"p12",0],
    [48200000,50000000,"p11",5],
    [50000000,51800000,"q11",5],
    [51800000,58500000,"q12",0],
    [58500000,65500000,"q13.1",4],
    [65500000,69400000,"q13.2",0],
    [69400000,75300000,"q13.3",3],
    [75300000,78000000,"q21.1",0],
    [78000000,81500000,"q21.21",2],
    [81500000,83200000,"q21.22",0],
    [83200000,86000000,"q21.23",1],
    [86000000,87100000,"q21.3",0],
    [87100000,92800000,"q22.1",3],
    [92800000,94200000,"q22.2",0],
    [94200000,97900000,"q22.3",3],
    [97900000,100100000,"q23",0],
    [100100000,106700000,"q24",2],
    [106700000,113200000,"q25",0],
    [113200000,119900000,"q26",3],
    [119900000,122800000,"q27",0],
    [122800000,127900000,"q28.1",2],
    [127900000,130100000,"q28.2",0],
    [130100000,138500000,"q28.3",4],
    [138500000,140600000,"q31.1",0],
    [140600000,145900000,"q31.21",1],
    [145900000,147500000,"q31.22",0],
    [147500000,150200000,"q31.23",1],
    [150200000,154600000,"q31.3",0],
    [154600000,160800000,"q32.1",4],
    [160800000,163600000,"q32.2",0],
    [163600000,169200000,"q32.3",4],
    [169200000,171000000,"q33",0],
    [171000000,175400000,"q34.1",3],
    [175400000,176600000,"q34.2",0],
    [176600000,182300000,"q34.3",4],
    [182300000,186200000,"q35.1",0],
    [186200000,190214555,"q35.2",1]],"5":[[0,4400000,"p15.33",0],
    [4400000,6300000,"p15.32",1],
    [6300000,9900000,"p15.31",0],
    [9900000,15000000,"p15.2",2],
    [15000000,18400000,"p15.1",0],
    [18400000,23300000,"p14.3",4],
    [23300000,24600000,"p14.2",0],
    [24600000,28900000,"p14.1",4],
    [28900000,33800000,"p13.3",0],
    [33800000,38400000,"p13.2",1],
    [38400000,42500000,"p13.1",0],
    [42500000,46100000,"p12",2],
    [46100000,48800000,"p11",5],
    [48800000,51400000,"q11.1",5],
    [51400000,59600000,"q11.2",0],
    [59600000,63600000,"q12.1",3],
    [63600000,63900000,"q12.2",0],
    [63900000,67400000,"q12.3",3],
    [67400000,69100000,"q13.1",0],
    [69100000,74000000,"q13.2",2],
    [74000000,77600000,"q13.3",0],
    [77600000,82100000,"q14.1",2],
    [82100000,83500000,"q14.2",0],
    [83500000,93000000,"q14.3",4],
    [93000000,98900000,"q15",0],
    [98900000,103400000,"q21.1",4],
    [103400000,105100000,"q21.2",0],
    [105100000,110200000,"q21.3",4],
    [110200000,112200000,"q22.1",0],
    [112200000,113800000,"q22.2",2],
    [113800000,115900000,"q22.3",0],
    [115900000,122100000,"q23.1",4],
    [122100000,127900000,"q23.2",0],
    [127900000,131200000,"q23.3",4],
    [131200000,136900000,"q31.1",0],
    [136900000,140100000,"q31.2",1],
    [140100000,145100000,"q31.3",0],
    [145100000,150400000,"q32",3],
    [150400000,153300000,"q33.1",0],
    [153300000,156300000,"q33.2",2],
    [156300000,160500000,"q33.3",0],
    [160500000,169000000,"q34",4],
    [169000000,173300000,"q35.1",0],
    [173300000,177100000,"q35.2",1],
    [177100000,181538259,"q35.3",0]],"6":[[0,2300000,"p25.3",0],
    [2300000,4200000,"p25.2",1],
    [4200000,7100000,"p25.1",0],
    [7100000,10600000,"p24.3",2],
    [10600000,11600000,"p24.2",0],
    [11600000,13400000,"p24.1",1],
    [13400000,15200000,"p23",0],
    [15200000,25200000,"p22.3",3],
    [25200000,27100000,"p22.2",0],
    [27100000,30500000,"p22.1",2],
    [30500000,32100000,"p21.33",0],
    [32100000,33500000,"p21.32",1],
    [33500000,36600000,"p21.31",0],
    [36600000,40500000,"p21.2",1],
    [40500000,46200000,"p21.1",0],
    [46200000,51800000,"p12.3",4],
    [51800000,53000000,"p12.2",0],
    [53000000,57200000,"p12.1",4],
    [57200000,58500000,"p11.2",0],
    [58500000,59800000,"p11.1",5],
    [59800000,62600000,"q11.1",5],
    [62600000,62700000,"q11.2",0],
    [62700000,69200000,"q12",4],
    [69200000,75200000,"q13",0],
    [75200000,83200000,"q14.1",2],
    [83200000,84200000,"q14.2",0],
    [84200000,87300000,"q14.3",2],
    [87300000,92500000,"q15",0],
    [92500000,98900000,"q16.1",4],
    [98900000,100000000,"q16.2",0],
    [100000000,105000000,"q16.3",4],
    [105000000,114200000,"q21",0],
    [114200000,117900000,"q22.1",3],
    [117900000,118100000,"q22.2",0],
    [118100000,125800000,"q22.31",4],
    [125800000,126800000,"q22.32",0],
    [126800000,130000000,"q22.33",3],
    [130000000,130900000,"q23.1",0],
    [130900000,134700000,"q23.2",2],
    [134700000,138300000,"q23.3",0],
    [138300000,142200000,"q24.1",3],
    [142200000,145100000,"q24.2",0],
    [145100000,148500000,"q24.3",3],
    [148500000,152100000,"q25.1",0],
    [152100000,155200000,"q25.2",2],
    [155200000,160600000,"q25.3",0],
    [160600000,164100000,"q26",2],
    [164100000,170805979,"q27",0]],"7":[[0,2800000,"p22.3",0],
    [2800000,4500000,"p22.2",1],
    [4500000,7200000,"p22.1",0],
    [7200000,13700000,"p21.3",4],
    [13700000,16500000,"p21.2",0],
    [16500000,20900000,"p21.1",4],
    [20900000,25500000,"p15.3",0],
    [25500000,27900000,"p15.2",2],
    [27900000,28800000,"p15.1",0],
    [28800000,34900000,"p14.3",3],
    [34900000,37100000,"p14.2",0],
    [37100000,43300000,"p14.1",3],
    [43300000,45400000,"p13",0],
    [45400000,49000000,"p12.3",3],
    [49000000,50500000,"p12.2",0],
    [50500000,53900000,"p12.1",3],
    [53900000,58100000,"p11.2",0],
    [58100000,60100000,"p11.1",5],
    [60100000,62100000,"q11.1",5],
    [62100000,67500000,"q11.21",0],
    [67500000,72700000,"q11.22",2],
    [72700000,77900000,"q11.23",0],
    [77900000,86700000,"q21.11",4],
    [86700000,88500000,"q21.12",0],
    [88500000,91500000,"q21.13",3],
    [91500000,93300000,"q21.2",0],
    [93300000,98400000,"q21.3",3],
    [98400000,104200000,"q22.1",0],
    [104200000,104900000,"q22.2",2],
    [104900000,107800000,"q22.3",0],
    [107800000,115000000,"q31.1",3],
    [115000000,117700000,"q31.2",0],
    [117700000,121400000,"q31.31",3],
    [121400000,124100000,"q31.32",0],
    [124100000,127500000,"q31.33",3],
    [127500000,129600000,"q32.1",0],
    [129600000,130800000,"q32.2",1],
    [130800000,132900000,"q32.3",0],
    [132900000,138500000,"q33",2],
    [138500000,143400000,"q34",0],
    [143400000,148200000,"q35",3],
    [148200000,152800000,"q36.1",0],
    [152800000,155200000,"q36.2",1],
    [155200000,159345973,"q36.3",0]],"8":[[0,2300000,"p23.3",0],
    [2300000,6300000,"p23.2",3],
    [6300000,12800000,"p23.1",0],
    [12800000,19200000,"p22",4],
    [19200000,23500000,"p21.3",0],
    [23500000,27500000,"p21.2",2],
    [27500000,29000000,"p21.1",0],
    [29000000,36700000,"p12",3],
    [36700000,38500000,"p11.23",0],
    [38500000,39900000,"p11.22",1],
    [39900000,43200000,"p11.21",0],
    [43200000,45200000,"p11.1",5],
    [45200000,47200000,"q11.1",5],
    [47200000,51300000,"q11.21",0],
    [51300000,51700000,"q11.22",3],
    [51700000,54600000,"q11.23",0],
    [54600000,60600000,"q12.1",2],
    [60600000,61300000,"q12.2",0],
    [61300000,65100000,"q12.3",2],
    [65100000,67100000,"q13.1",0],
    [67100000,69600000,"q13.2",2],
    [69600000,72000000,"q13.3",0],
    [72000000,74600000,"q21.11",4],
    [74600000,74700000,"q21.12",0],
    [74700000,83500000,"q21.13",3],
    [83500000,85900000,"q21.2",0],
    [85900000,92300000,"q21.3",4],
    [92300000,97900000,"q22.1",0],
    [97900000,100500000,"q22.2",1],
    [100500000,105100000,"q22.3",0],
    [105100000,109500000,"q23.1",3],
    [109500000,111100000,"q23.2",0],
    [111100000,116700000,"q23.3",4],
    [116700000,118300000,"q24.11",0],
    [118300000,121500000,"q24.12",2],
    [121500000,126300000,"q24.13",0],
    [126300000,130400000,"q24.21",2],
    [130400000,135400000,"q24.22",0],
    [135400000,138900000,"q24.23",3],
    [138900000,145138636,"q24.3",0]],"9":[[0,2200000,"p24.3",0],
    [2200000,4600000,"p24.2",1],
    [4600000,9000000,"p24.1",0],
    [9000000,14200000,"p23",3],
    [14200000,16600000,"p22.3",0],
    [16600000,18500000,"p22.2",1],
    [18500000,19900000,"p22.1",0],
    [19900000,25600000,"p21.3",4],
    [25600000,28000000,"p21.2",0],
    [28000000,33200000,"p21.1",4],
    [33200000,36300000,"p13.3",0],
    [36300000,37900000,"p13.2",1],
    [37900000,39000000,"p13.1",0],
    [39000000,40000000,"p12",2],
    [40000000,42200000,"p11.2",0],
    [42200000,43000000,"p11.1",5],
    [43000000,45500000,"q11",5],
    [45500000,61500000,"q12",6],
    [61500000,65000000,"q13",0],
    [65000000,69300000,"q21.11",1],
    [69300000,71300000,"q21.12",0],
    [71300000,76600000,"q21.13",2],
    [76600000,78500000,"q21.2",0],
    [78500000,81500000,"q21.31",2],
    [81500000,84300000,"q21.32",0],
    [84300000,87800000,"q21.33",2],
    [87800000,89200000,"q22.1",0],
    [89200000,91200000,"q22.2",1],
    [91200000,93900000,"q22.31",0],
    [93900000,96500000,"q22.32",1],
    [96500000,99800000,"q22.33",0],
    [99800000,105400000,"q31.1",4],
    [105400000,108500000,"q31.2",0],
    [108500000,112100000,"q31.3",1],
    [112100000,114900000,"q32",0],
    [114900000,119800000,"q33.1",3],
    [119800000,123100000,"q33.2",0],
    [123100000,127500000,"q33.3",1],
    [127500000,130600000,"q34.11",0],
    [130600000,131100000,"q34.12",1],
    [131100000,133100000,"q34.13",0],
    [133100000,134500000,"q34.2",1],
    [134500000,138394717,"q34.3",0]],"10":[[0,3000000,"p15.3",0],
    [3000000,3800000,"p15.2",1],
    [3800000,6600000,"p15.1",0],
    [6600000,12200000,"p14",3],
    [12200000,17300000,"p13",0],
    [17300000,18300000,"p12.33",3],
    [18300000,18400000,"p12.32",0],
    [18400000,22300000,"p12.31",3],
    [22300000,24300000,"p12.2",0],
    [24300000,29300000,"p12.1",2],
    [29300000,31100000,"p11.23",0],
    [31100000,34200000,"p11.22",1],
    [34200000,38000000,"p11.21",0],
    [38000000,39800000,"p11.1",5],
    [39800000,41600000,"q11.1",5],
    [41600000,45500000,"q11.21",0],
    [45500000,48600000,"q11.22",1],
    [48600000,51100000,"q11.23",0],
    [51100000,59400000,"q21.1",4],
    [59400000,62800000,"q21.2",0],
    [62800000,68800000,"q21.3",4],
    [68800000,73100000,"q22.1",0],
    [73100000,75900000,"q22.2",2],
    [75900000,80300000,"q22.3",0],
    [80300000,86100000,"q23.1",4],
    [86100000,87700000,"q23.2",0],
    [87700000,91100000,"q23.31",3],
    [91100000,92300000,"q23.32",0],
    [92300000,95300000,"q23.33",2],
    [95300000,97500000,"q24.1",0],
    [97500000,100100000,"q24.2",2],
    [100100000,101200000,"q24.31",0],
    [101200000,103100000,"q24.32",1],
    [103100000,104000000,"q24.33",0],
    [104000000,110100000,"q25.1",4],
    [110100000,113100000,"q25.2",0],
    [113100000,117300000,"q25.3",3],
    [117300000,119900000,"q26.11",0],
    [119900000,121400000,"q26.12",2],
    [121400000,125700000,"q26.13",0],
    [125700000,128800000,"q26.2",2],
    [128800000,133797422,"q26.3",0]],"11":[[0,2800000,"p15.5",0],
    [2800000,11700000,"p15.4",2],
    [11700000,13800000,"p15.3",0],
    [13800000,16900000,"p15.2",2],
    [16900000,22000000,"p15.1",0],
    [22000000,26200000,"p14.3",4],
    [26200000,27200000,"p14.2",0],
    [27200000,31000000,"p14.1",3],
    [31000000,36400000,"p13",0],
    [36400000,43400000,"p12",4],
    [43400000,48800000,"p11.2",0],
    [48800000,51000000,"p11.12",3],
    [51000000,53400000,"p11.11",5],
    [53400000,55800000,"q11",5],
    [55800000,60100000,"q12.1",3],
    [60100000,61900000,"q12.2",0],
    [61900000,63600000,"q12.3",1],
    [63600000,66100000,"q13.1",0],
    [66100000,68700000,"q13.2",1],
    [68700000,70500000,"q13.3",0],
    [70500000,75500000,"q13.4",2],
    [75500000,77400000,"q13.5",0],
    [77400000,85900000,"q14.1",4],
    [85900000,88600000,"q14.2",0],
    [88600000,93000000,"q14.3",4],
    [93000000,97400000,"q21",0],
    [97400000,102300000,"q22.1",4],
    [102300000,103000000,"q22.2",0],
    [103000000,110600000,"q22.3",4],
    [110600000,112700000,"q23.1",0],
    [112700000,114600000,"q23.2",2],
    [114600000,121300000,"q23.3",0],
    [121300000,124000000,"q24.1",2],
    [124000000,127900000,"q24.2",0],
    [127900000,130900000,"q24.3",2],
    [130900000,135086622,"q25",0]],"12":[[0,3200000,"p13.33",0],
    [3200000,5300000,"p13.32",1],
    [5300000,10000000,"p13.31",0],
    [10000000,12600000,"p13.2",3],
    [12600000,14600000,"p13.1",0],
    [14600000,19800000,"p12.3",4],
    [19800000,21100000,"p12.2",0],
    [21100000,26300000,"p12.1",4],
    [26300000,27600000,"p11.23",0],
    [27600000,30500000,"p11.22",2],
    [30500000,33200000,"p11.21",0],
    [33200000,35500000,"p11.1",5],
    [35500000,37800000,"q11",5],
    [37800000,46000000,"q12",4],
    [46000000,48700000,"q13.11",0],
    [48700000,51100000,"q13.12",1],
    [51100000,54500000,"q13.13",0],
    [54500000,56200000,"q13.2",1],
    [56200000,57700000,"q13.3",0],
    [57700000,62700000,"q14.1",3],
    [62700000,64700000,"q14.2",0],
    [64700000,67300000,"q14.3",2],
    [67300000,71100000,"q15",0],
    [71100000,75300000,"q21.1",3],
    [75300000,79900000,"q21.2",0],
    [79900000,86300000,"q21.31",4],
    [86300000,88600000,"q21.32",0],
    [88600000,92200000,"q21.33",4],
    [92200000,95800000,"q22",0],
    [95800000,101200000,"q23.1",3],
    [101200000,103500000,"q23.2",0],
    [103500000,108600000,"q23.3",2],
    [108600000,111300000,"q24.11",0],
    [111300000,111900000,"q24.12",1],
    [111900000,113900000,"q24.13",0],
    [113900000,116400000,"q24.21",2],
    [116400000,117700000,"q24.22",0],
    [117700000,120300000,"q24.23",2],
    [120300000,125400000,"q24.31",0],
    [125400000,128700000,"q24.32",2],
    [128700000,133275309,"q24.33",0]],"13":[[0,4600000,"p13",6],
    [4600000,10100000,"p12",7],
    [10100000,16500000,"p11.2",6],
    [16500000,17700000,"p11.1",5],
    [17700000,18900000,"q11",5],
    [18900000,22600000,"q12.11",0],
    [22600000,24900000,"q12.12",1],
    [24900000,27200000,"q12.13",0],
    [27200000,28300000,"q12.2",1],
    [28300000,31600000,"q12.3",0],
    [31600000,33400000,"q13.1",2],
    [33400000,34900000,"q13.2",0],
    [34900000,39500000,"q13.3",3],
    [39500000,44600000,"q14.11",0],
    [44600000,45200000,"q14.12",1],
    [45200000,46700000,"q14.13",0],
    [46700000,50300000,"q14.2",2],
    [50300000,54700000,"q14.3",0],
    [54700000,59000000,"q21.1",4],
    [59000000,61800000,"q21.2",0],
    [61800000,65200000,"q21.31",3],
    [65200000,68100000,"q21.32",0],
    [68100000,72800000,"q21.33",4],
    [72800000,74900000,"q22.1",0],
    [74900000,76700000,"q22.2",2],
    [76700000,78500000,"q22.3",0],
    [78500000,87100000,"q31.1",4],
    [87100000,89400000,"q31.2",0],
    [89400000,94400000,"q31.3",4],
    [94400000,97500000,"q32.1",0],
    [97500000,98700000,"q32.2",1],
    [98700000,101100000,"q32.3",0],
    [101100000,104200000,"q33.1",4],
    [104200000,106400000,"q33.2",0],
    [106400000,109600000,"q33.3",4],
    [109600000,114364328,"q34",0]],"14":[[0,3600000,"p13",6],
    [3600000,8000000,"p12",7],
    [8000000,16100000,"p11.2",6],
    [16100000,17200000,"p11.1",5],
    [17200000,18200000,"q11.1",5],
    [18200000,24100000,"q11.2",0],
    [24100000,32900000,"q12",4],
    [32900000,34800000,"q13.1",0],
    [34800000,36100000,"q13.2",2],
    [36100000,37400000,"q13.3",0],
    [37400000,43000000,"q21.1",4],
    [43000000,46700000,"q21.2",0],
    [46700000,50400000,"q21.3",4],
    [50400000,53600000,"q22.1",0],
    [53600000,55000000,"q22.2",1],
    [55000000,57600000,"q22.3",0],
    [57600000,61600000,"q23.1",3],
    [61600000,64300000,"q23.2",0],
    [64300000,67400000,"q23.3",2],
    [67400000,69800000,"q24.1",0],
    [69800000,73300000,"q24.2",2],
    [73300000,78800000,"q24.3",0],
    [78800000,83100000,"q31.1",4],
    [83100000,84400000,"q31.2",0],
    [84400000,89300000,"q31.3",4],
    [89300000,91400000,"q32.11",0],
    [91400000,94200000,"q32.12",1],
    [94200000,95800000,"q32.13",0],
    [95800000,100900000,"q32.2",2],
    [100900000,102700000,"q32.31",0],
    [102700000,103500000,"q32.32",2],
    [103500000,107043718,"q32.33",0]],"15":[[0,4200000,"p13",6],
    [4200000,9700000,"p12",7],
    [9700000,17500000,"p11.2",6],
    [17500000,19000000,"p11.1",5],
    [19000000,20500000,"q11.1",5],
    [20500000,25500000,"q11.2",0],
    [25500000,27800000,"q12",2],
    [27800000,30000000,"q13.1",0],
    [30000000,30900000,"q13.2",2],
    [30900000,33400000,"q13.3",0],
    [33400000,39800000,"q14",3],
    [39800000,42500000,"q15.1",0],
    [42500000,43300000,"q15.2",1],
    [43300000,44500000,"q15.3",0],
    [44500000,49200000,"q21.1",3],
    [49200000,52600000,"q21.2",0],
    [52600000,58800000,"q21.3",3],
    [58800000,59000000,"q22.1",0],
    [59000000,63400000,"q22.2",1],
    [63400000,66900000,"q22.31",0],
    [66900000,67000000,"q22.32",1],
    [67000000,67200000,"q22.33",0],
    [67200000,72400000,"q23",1],
    [72400000,74900000,"q24.1",0],
    [74900000,76300000,"q24.2",1],
    [76300000,78000000,"q24.3",0],
    [78000000,81400000,"q25.1",2],
    [81400000,84700000,"q25.2",0],
    [84700000,88500000,"q25.3",2],
    [88500000,93800000,"q26.1",0],
    [93800000,98000000,"q26.2",2],
    [98000000,101991189,"q26.3",0]],"16":[[0,7800000,"p13.3",0],
    [7800000,10400000,"p13.2",2],
    [10400000,12500000,"p13.13",0],
    [12500000,14700000,"p13.12",2],
    [14700000,16700000,"p13.11",0],
    [16700000,21200000,"p12.3",2],
    [21200000,24200000,"p12.2",0],
    [24200000,28500000,"p12.1",2],
    [28500000,35300000,"p11.2",0],
    [35300000,36800000,"p11.1",5],
    [36800000,38400000,"q11.1",5],
    [38400000,47000000,"q11.2",6],
    [47000000,52600000,"q12.1",0],
    [52600000,56000000,"q12.2",2],
    [56000000,57300000,"q13",0],
    [57300000,66600000,"q21",4],
    [66600000,70800000,"q22.1",0],
    [70800000,72800000,"q22.2",2],
    [72800000,74100000,"q22.3",0],
    [74100000,79200000,"q23.1",3],
    [79200000,81600000,"q23.2",0],
    [81600000,84100000,"q23.3",2],
    [84100000,87000000,"q24.1",0],
    [87000000,88700000,"q24.2",1],
    [88700000,90338345,"q24.3",0]],"17":[[0,3400000,"p13.3",0],
    [3400000,6500000,"p13.2",2],
    [6500000,10800000,"p13.1",0],
    [10800000,16100000,"p12",3],
    [16100000,22700000,"p11.2",0],
    [22700000,25100000,"p11.1",5],
    [25100000,27400000,"q11.1",5],
    [27400000,33500000,"q11.2",0],
    [33500000,39800000,"q12",2],
    [39800000,40200000,"q21.1",0],
    [40200000,42800000,"q21.2",1],
    [42800000,46800000,"q21.31",0],
    [46800000,49300000,"q21.32",1],
    [49300000,52100000,"q21.33",0],
    [52100000,59500000,"q22",3],
    [59500000,60200000,"q23.1",0],
    [60200000,63100000,"q23.2",3],
    [63100000,64600000,"q23.3",0],
    [64600000,66200000,"q24.1",2],
    [66200000,69100000,"q24.2",0],
    [69100000,72900000,"q24.3",3],
    [72900000,76800000,"q25.1",0],
    [76800000,77200000,"q25.2",1],
    [77200000,83257441,"q25.3",0]],"18":[[0,2900000,"p11.32",0],
    [2900000,7200000,"p11.31",2],
    [7200000,8500000,"p11.23",0],
    [8500000,10900000,"p11.22",1],
    [10900000,15400000,"p11.21",0],
    [15400000,18500000,"p11.1",5],
    [18500000,21500000,"q11.1",5],
    [21500000,27500000,"q11.2",0],
    [27500000,35100000,"q12.1",4],
    [35100000,39500000,"q12.2",0],
    [39500000,45900000,"q12.3",3],
    [45900000,50700000,"q21.1",0],
    [50700000,56200000,"q21.2",3],
    [56200000,58600000,"q21.31",0],
    [58600000,61300000,"q21.32",2],
    [61300000,63900000,"q21.33",0],
    [63900000,69100000,"q22.1",4],
    [69100000,71000000,"q22.2",0],
    [71000000,75400000,"q22.3",1],
    [75400000,80373285,"q23",0]],"19":[[0,6900000,"p13.3",0],
    [6900000,12600000,"p13.2",1],
    [12600000,13800000,"p13.13",0],
    [13800000,16100000,"p13.12",1],
    [16100000,19900000,"p13.11",0],
    [19900000,24200000,"p12",6],
    [24200000,26200000,"p11",5],
    [26200000,28100000,"q11",5],
    [28100000,31900000,"q12",6],
    [31900000,35100000,"q13.11",0],
    [35100000,37800000,"q13.12",1],
    [37800000,38200000,"q13.13",0],
    [38200000,42900000,"q13.2",1],
    [42900000,44700000,"q13.31",0],
    [44700000,47500000,"q13.32",1],
    [47500000,50900000,"q13.33",0],
    [50900000,53100000,"q13.41",1],
    [53100000,55800000,"q13.42",0],
    [55800000,58617616,"q13.43",1]],"20":[[0,5100000,"p13",0],
    [5100000,9200000,"p12.3",3],
    [9200000,12000000,"p12.2",0],
    [12000000,17900000,"p12.1",3],
    [17900000,21300000,"p11.23",0],
    [21300000,22300000,"p11.22",1],
    [22300000,25700000,"p11.21",0],
    [25700000,28100000,"p11.1",5],
    [28100000,30400000,"q11.1",5],
    [30400000,33500000,"q11.21",0],
    [33500000,35800000,"q11.22",1],
    [35800000,39000000,"q11.23",0],
    [39000000,43100000,"q12",3],
    [43100000,43500000,"q13.11",0],
    [43500000,47800000,"q13.12",1],
    [47800000,51200000,"q13.13",0],
    [51200000,56400000,"q13.2",3],
    [56400000,57800000,"q13.31",0],
    [57800000,59700000,"q13.32",2],
    [59700000,64444167,"q13.33",0]],"21":[[0,3100000,"p13",6],
    [3100000,7000000,"p12",7],
    [7000000,10900000,"p11.2",6],
    [10900000,12000000,"p11.1",5],
    [12000000,13000000,"q11.1",5],
    [13000000,15000000,"q11.2",0],
    [15000000,22600000,"q21.1",4],
    [22600000,25500000,"q21.2",0],
    [25500000,30200000,"q21.3",3],
    [30200000,34400000,"q22.11",0],
    [34400000,36400000,"q22.12",2],
    [36400000,38300000,"q22.13",0],
    [38300000,41200000,"q22.2",2],
    [41200000,46709983,"q22.3",0]],"22":[[0,4300000,"p13",6],
    [4300000,9400000,"p12",7],
    [9400000,13700000,"p11.2",6],
    [13700000,15000000,"p11.1",5],
    [15000000,17400000,"q11.1",5],
    [17400000,21700000,"q11.21",0],
    [21700000,23100000,"q11.22",1],
    [23100000,25500000,"q11.23",0],
    [25500000,29200000,"q12.1",2],
    [29200000,31800000,"q12.2",0],
    [31800000,37200000,"q12.3",2],
    [37200000,40600000,"q13.1",0],
    [40600000,43800000,"q13.2",2],
    [43800000,48100000,"q13.31",0],
    [48100000,49100000,"q13.32",2],
    [49100000,50818468,"q13.33",0]],"X":[[0,4400000,"p22.33",0],
    [4400000,6100000,"p22.32",2],
    [6100000,9600000,"p22.31",0],
    [9600000,17400000,"p22.2",2],
    [17400000,19200000,"p22.13",0],
    [19200000,21900000,"p22.12",2],
    [21900000,24900000,"p22.11",0],
    [24900000,29300000,"p21.3",4],
    [29300000,31500000,"p21.2",0],
    [31500000,37800000,"p21.1",4],
    [37800000,42500000,"p11.4",0],
    [42500000,47600000,"p11.3",3],
    [47600000,50100000,"p11.23",0],
    [50100000,54800000,"p11.22",1],
    [54800000,58100000,"p11.21",0],
    [58100000,61000000,"p11.1",5],
    [61000000,63800000,"q11.1",5],
    [63800000,65400000,"q11.2",0],
    [65400000,68500000,"q12",2],
    [68500000,73000000,"q13.1",0],
    [73000000,74700000,"q13.2",2],
    [74700000,76800000,"q13.3",0],
    [76800000,85400000,"q21.1",4],
    [85400000,87000000,"q21.2",0],
    [87000000,92700000,"q21.31",4],
    [92700000,94300000,"q21.32",0],
    [94300000,99100000,"q21.33",3],
    [99100000,103300000,"q22.1",0],
    [103300000,104500000,"q22.2",2],
    [104500000,109400000,"q22.3",0],
    [109400000,117400000,"q23",3],
    [117400000,121800000,"q24",0],
    [121800000,129500000,"q25",4],
    [129500000,131300000,"q26.1",0],
    [131300000,134500000,"q26.2",1],
    [134500000,138900000,"q26.3",0],
    [138900000,141200000,"q27.1",3],
    [141200000,143000000,"q27.2",0],
    [143000000,148000000,"q27.3",4],
    [148000000,156040895,"q28",0]],"Y":[[0,300000,"p11.32",0],
    [300000,600000,"p11.31",2],
    [600000,10300000,"p11.2",0],
    [10300000,10400000,"p11.1",5],
    [10400000,10600000,"q11.1",5],
    [10600000,12400000,"q11.21",0],
    [12400000,17100000,"q11.221",2],
    [17100000,19600000,"q11.222",0],
    [19600000,23800000,"q11.223",2],
    [23800000,26600000,"q11.23",0],
    [26600000,57227415,"q12",6]]},
};

/** Chromosome lengths per build, derived from the last band end. */
export const BUILD_CHROM_LENGTHS: Record<GenomeBuild, Record<string, number>> = {
  hg19: {"1":249250621,"2":243199373,"3":198022430,"4":191154276,"5":180915260,"6":171115067,"7":159138663,"8":146364022,"9":141213431,"10":135534747,"11":135006516,"12":133851895,"13":115169878,"14":107349540,"15":102531392,"16":90354753,"17":81195210,"18":78077248,"19":59128983,"20":63025520,"21":48129895,"22":51304566,"X":155270560,"Y":59373566},
  hg38: {"1":248956422,"2":242193529,"3":198295559,"4":190214555,"5":181538259,"6":170805979,"7":159345973,"8":145138636,"9":138394717,"10":133797422,"11":135086622,"12":133275309,"13":114364328,"14":107043718,"15":101991189,"16":90338345,"17":83257441,"18":80373285,"19":58617616,"20":64444167,"21":46709983,"22":50818468,"X":156040895,"Y":57227415},
};

export const IDEOGRAM_CHROMS = ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","X","Y"];
